export default "__VITE_ASSET__e8gkWRh3__"